import styled from '@emotion/styled';
import { ICustomTheme } from 'interfaces';
import { Chip } from '@material-ui/core';

export const StyledBannerChip = styled(Chip)(
  ({ theme }: { theme: ICustomTheme }) => ({
    background: `${theme.colors.paletteFromBO.main}12`,
    color: theme.colors.paletteFromBO.main,
    fontWeight: 'bold',
    fontSize: 18,
    marginRight: theme.spacing(1),
    padding: theme.spacing(2, 2),
    borderRadius: 30,
    cursor: 'pointer',
    minWidth: '14ch',
  }),
);

export const StyledAdditionalQuestionsContainer = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  marginBottom: 16,
}));

export const StyledAdditionalQuestionsDatesContainer = styled('div')(() => ({
  marginRight: 64,
  marginBottom: 16,
}));

export const StyledAdditionalQuestion = styled('span')(
  ({ isMobile }: { isMobile: boolean }) => ({
    fontSize: isMobile ? 14 : 16,
  }),
);

export const StyledAdditionalResponse = styled('span')(
  ({ isMobile, theme }: { isMobile: boolean; theme: ICustomTheme }) => ({
    fontSize: isMobile ? 14 : 16,
    fontWeight: 700,
    color: theme.colors.grey.dark,
  }),
);

export const StyledAdditionalEndDate = styled('span')(
  ({ isMobile, theme }: { isMobile: boolean; theme: ICustomTheme }) => ({
    margin: theme.spacing(2, 0),
    fontSize: isMobile ? 14 : 16,
    fontWeight: 700,
    color: theme.colors.grey.dark,
  }),
);

export const StyledAdditionalQuestionsDistributorContainer = styled('div')(
  () => ({
    minWidth: 'max-content',
  }),
);
